import { InjectionToken } from '@angular/core';
import { FirebaseStorage, getStorage } from 'firebase/storage';

export const STORAGE_TOKEN = new InjectionToken<FirebaseStorage>('Firebase Storage', {
  providedIn: 'root',
  factory: () => getStorage()
});
